import "./EditAppointmentPage.css";
import { Button } from "../../components/Button";
import { Riepilogo } from "../../components/Riepilogo";
import { Informative } from "../../components/Informative";
import { FormDatiUtente } from "../../components/FormDatiUtente";
import { ErrorModal } from "../../components/ErrorModal";
import { t, getWeekDay, getDayAndMonth, getFullMinute } from "../../services/formatters";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import widgetOptions from "../../config/widgets.json";
import { useEditAppointmentPage } from "./useEditAppointmentPage";
import { useFilialiPage } from "../FilialiPage/useFilialiPage";
import { FormDatiUtenteRiconosciuto } from "../../components/FormDatiUtenteRiconosciuto";
import { InformativeC5 } from "../../components/InformativeC5";
import { useEffect } from "react";
import { useComponentMetric } from "../../lib/otel";

export const EditAppointmentPage = () => {
    const { read, next, vuoleRicontatto, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError, getAppuntamentoData, switchToEditFormData, knownUser } =
        useEditAppointmentPage();
const metric = useComponentMetric("edit-appointment");
    const { update, subSlider, daySlider, onFilialiSlideChange, onGiorniSlideChange, isFilialiSlideBusy, showMap, currentMapToShow } = useFilialiPage();

    useEffect(() => {
        if (fetchError) {
            metric.trackError(fetchErrorMessage || "errore modifica appuntamento");
        }
    }, [fetchError]);


    return (
        <div id="edit-appointment-page">
            <div className={`section page-title-component center-on-tablet`}>
                <h1>
                    <span>Ciao {read("nome")}!</span> <br /> <span>Il tuo appuntamento:</span>
                </h1>
            </div>

            {/* SLIDERS */}
            {/* filiali */}
            <div id="subs-splide" className={`section full-screen on-mobile`}>
                <div className="fade"></div>
                <Splide
                    ref={subSlider}
                    options={{ ...widgetOptions.splideFiliali, drag: false }}
                    onMoved={(splide, newIdx) => {
                        onFilialiSlideChange(newIdx);
                    }}
                    onClick={(splide, slide) => {}}
                    onReady={(splide, slide) => {}}>
                    {[read("filiali")[0]].map((i, idx) => (
                        <SplideSlide key={`${i.filiale}-${idx}`}>
                            <div className={`white-box subsidiary-card-component clickable  ${currentMapToShow == `map-${idx}` ? "show-map" : ""}`}>
                                <h2>{i.nomeFiliale}</h2>
                                <p aria-label={i.indirizzo} className={`subsidiary-card-subtitle ${!i.indirizzo ? "invisible" : ""}`}>
                                    {i.indirizzo || "&nbsp;"}
                                </p>

                                <div className={`subsidiary-card-show-map text-sm ${currentMapToShow == `map-${idx}` ? "anim-pulse anim-slow" : ""}`}>
                                    <span
                                        onClick={() => {
                                            showMap(`map-${idx}`, i.coordinate);
                                        }}>
                                        {currentMapToShow == `map-${idx}` ? t("nascondi_mappa") : t("mostra_mappa")}
                                    </span>
                                </div>

                                <div className="map-container">
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                        }}
                                        id={`map-${idx}`}></div>
                                </div>
                            </div>
                        </SplideSlide>
                    ))}
                </Splide>
            </div>

            {/* giorni */}
            <div id="days-splide" className="section full-screen on-mobile">
                <div className="fade"></div>
                <Splide
                    ref={daySlider}
                    options={widgetOptions.splideGiorni}
                    onMove={() => {}}
                    onDragging={() => {}}
                    onMoved={(splide, newIdx) => {
                        onGiorniSlideChange(newIdx);
                    }}
                    onReady={() => {}}>
                    {read("disponibilita").map((i, idx) => (
                        <SplideSlide key={`${i.data}-${idx}`}>
                            <div className={`white-box day-card-component text-uppercase clickable ${idx == 3 ? "show-next-days" : ""}`}>
                                <h2 className="actual-date">
                                    {getWeekDay(i.data, true)}
                                    {getWeekDay(i.data, true) && <br />}
                                    <span dangerouslySetInnerHTML={{ __html: getDayAndMonth(i.data, true) || "" }}></span>
                                </h2>

                                <h2 className="fake-date">Mostra successive</h2>
                            </div>
                        </SplideSlide>
                    ))}
                </Splide>
            </div>

            {/* ore */}
            <div className={`hour-grid-component`}>
                {isFilialiSlideBusy() && (
                    <>
                        <div className="sliders-loader loading-placeholder hours-loader"></div>
                    </>
                )}
                <div className="flex-row hours-grid__cells-container">
                    {read("orari").map((i, idx) => (
                        <div
                            key={`hour-grid-${idx}`}
                            onClick={() => {
                                if (!i.disponibile) return;
                                update("orarioScelto", { idx, hour: i.hour, minute: i.minute });
                            }}
                            className={`white-box hour-cell flex-cell ${
                                read("orarioScelto") && i.hour == read("orarioScelto").hour && i.minute == read("orarioScelto").minute && i.disponibile == true ? "is-active" : ""
                            } ${!i.disponibile ? "disabled" : ""}`}>
                            <h2>{`${i.hour}:${getFullMinute(i.minute)}`}</h2>
                        </div>
                    ))}
                </div>
            </div>

            <br />
            {read("filialeScelta") && <Riepilogo />}

            {knownUser && <FormDatiUtenteRiconosciuto onClick={switchToEditFormData} />}
            {!knownUser && <FormDatiUtente lockFields={true} nome={getAppuntamentoData("utente").nome} cognome={getAppuntamentoData("utente").cognome} title={t("compila_dati")} />}

            {read("prodotto") == 3 ? <InformativeC5 isEdit={true} hideProfession={false} /> : <Informative />}

            <div className="section text-center">
                <Button
                    id="go-to-select-state-btn"
                    disabled={false}
                    onClick={next}
                    classList="btn-responsive always-style"
                    loading={isCreaAppuntamentoBusy()}
                    text={vuoleRicontatto ? t("avanti") : t("fissa_appuntamento")}
                />
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>
        </div>
    );
};
